import { TStatus } from "./global.type";

export const DModalState = {
    prefix:'',
    title:'',
    suffix:'',
    open: false,
    step: 1,
    loading: false,
    status: '' as TStatus,
    detail:'',
}

export const DPaginationProps = {
    page:1,
    keyword:'',
    limit:50
}